import { render, staticRenderFns } from "./TheDocumentTasks.vue?vue&type=template&id=8e06f644&scoped=true&"
import script from "./TheDocumentTasks.vue?vue&type=script&lang=js&"
export * from "./TheDocumentTasks.vue?vue&type=script&lang=js&"
import style0 from "./TheDocumentTasks.vue?vue&type=style&index=0&id=8e06f644&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e06f644",
  null
  
)

export default component.exports